import React from 'react';
import SmallAvatar from './SmallAvatar';

type Props = {
  fillIndicator?: boolean;
  image: any;
};

export default function AllAssetAvatar({
  fillIndicator,
  image
}: Readonly<Props>) {
  return (
    <div>
      <div className="relative -mt-3 h-[3.5rem] w-[3.5rem]">
        <div className="flex h-full flex-col items-center justify-center">
          <div className="relative -m-0 flex">
            <div className="relative -mr-3 p-0">
              <SmallAvatar image={image} />
            </div>
            <div className="relative m-0 p-0">
              <SmallAvatar image={image} />
            </div>
          </div>
          <div className="relative -m-4 flex">
            <div className="relative -mr-3 p-0">
              <SmallAvatar image={image} />
            </div>
            <div className="relative m-0 p-0">
              <SmallAvatar image={image} />
            </div>
          </div>
        </div>
        <div
          className={`absolute -bottom-4 right-0 h-4 w-4 rounded-full border-2 border-primary-800 ${
            fillIndicator ? 'bg-primary-900' : 'bg-white'
          }`}
        ></div>
      </div>
    </div>
  );
}
